import {action, computed, makeObservable, observable} from "mobx";
import TemplateEditorFormStore from "./TemplateEditorFormStore";
import TemplateEditorVariablesStore from "./TemplateEditorVariablesStore";
import ImagePickerStore from "./ImagePickerStore";
import {debounce} from "lodash";

export default class TemplateEditorStore {
  requiredFieldsError = false;
  html = null;
  text = null;
  design = null;
  tags = [];
  unlayer = null;

  formEditorStore = null;
  variablesEditorStore = null;
  imagePickerStore = null;

  constructor() {
    makeObservable(this, {
      requiredFieldsError: observable,
      formEditorStore: observable,
      variablesEditorStore: observable,
      imagePickerStore: observable,
      html: observable,
      text: observable,
      design: observable,
      tags: observable,
      unlayer: observable,
      subject: computed,
      showRequiredFieldsError: action,
      removeAllMappedVariables: action,
      updateField: action,
      exportData: action,
      addVariable: action
    });

    this.formEditorStore = new TemplateEditorFormStore();
    this.imagePickerStore = new ImagePickerStore();
    this.variablesEditorStore = new TemplateEditorVariablesStore({ setTags: (tags) => this.onHandleTags(tags) });
  }

  init({ unlayer }) {
    this.unlayer = unlayer;
    if (this.variablesEditorStore.variables.length > 0) {
      this.variablesEditorStore.onHandleTags();
    }
  }

  onHandleTags(tags) {
    if (this.unlayer) {
      this.unlayer.setMergeTags(tags);
    }
  }

  get subject(){
    return this.formEditorStore?.currentSubject || "";
  }

  updateField(field, value) {
    const fieldMapping = {
      sources: (value) => this.variablesEditorStore.setSources(value),
      from: (value) => this.formEditorStore.updateFrom(value),
      sender_name: (value) => this.formEditorStore.updateField('senderName', value),
      senderName: (value) => this.formEditorStore.updateField('senderName', value),
      to: (value) => this.formEditorStore.updateField('to', value),
      subject: (value) => this.formEditorStore.updateField('subject', value),
      cc: (value) => this.formEditorStore.updateField('cc', value),
      bcc: (value) => this.formEditorStore.updateField('bcc', value),
      description: (value) => this.formEditorStore.updateField('description', value),
    };

    if (fieldMapping[field]) {
      fieldMapping[field](value);
    } else {
      this[field] = value;
    }
  }

  addVariable(variable){
    if (!variable) {
      return;
    }
    this.variablesEditorStore.addVariable(variable);
  }

  exportData() {
    return {
      html: this.html,
      design: this.design,
      form: {
        from: this.formEditorStore.from,
        senderName: this.formEditorStore.senderName,
        to: this.formEditorStore.to,
        subject: this.formEditorStore.subject,
        cc: this.formEditorStore.cc,
        bcc: this.formEditorStore.bcc,
        description: this.formEditorStore.description,
      },
      variables: this.variablesEditorStore.variables,
    }
  }

  removeAllMappedVariables() {
    this.variablesEditorStore.removeMappedVariables();
  }

  onClearRequiredFieldsError() {
    this.requiredFieldsError = false;
  }

  showRequiredFieldsError() {
    if (this.requiredFieldsError === true) return;

    this.requiredFieldsError = true;
    const hideModal = debounce(() => {
      this.onClearRequiredFieldsError();
    }, 5000); // Increased from 5000ms to give users more time to see the error message
    hideModal();
  }

  clear() {
    this.html = null;
    this.text = null;
    this.design = null;
    this.formEditorStore.clean();
    this.variablesEditorStore.clean();
  }
}